import React from "react";
import { useTranslation } from "react-i18next";
import { CircleCheckBig } from "lucide-react";
import { NavLink, useSearchParams } from "react-router-dom"; // <--- DODANO useSearchParams
import Button from "../../components/ui/Button";

function PaymentSuccess() {
  const { t } = useTranslation("payment");
  const [searchParams] = useSearchParams(); // <--- ODCZYTUJEMY PARAMETRY Z URL

  // Szukamy "slug" w adresie. Jeśli go nie ma, domyślnie wrócimy na stronę główną ("/")
  const slug = searchParams.get("slug");
  const returnUrl = slug ? `/projects/${slug}` : "/"; // Dostosuj "/projects/" do swoich ścieżek!

  return (
    <div className="last-payment-page success">
      <div className="payment-container">
        <CircleCheckBig className="success-icon" />

        <h1 className="last-payment-title">{t("success.title")}</h1>

        <p className="last-payment-text">{t("success.description")}</p>

        <div className="buttons-container">
          {/* Przycisk 1: Powrót do zbiórki */}
          <NavLink to={returnUrl}>
            <Button variant="primary" size="lg">
              {t("success.primary", "Wróć do zbiórki")}
            </Button>
          </NavLink>

          {/* Przycisk 2: Przejście na stronę główną (lub np. do listy wszystkich zbiórek) */}
          <NavLink to="/">
            <Button variant="secondary" size="lg">
              {t("success.secondary", "Strona główna")}
            </Button>
          </NavLink>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
